import { useEffect, useState } from 'react'
import { useLogin, useNotify } from 'react-admin'
import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import log from 'loglevel'
import { last, replace, split } from 'lodash/fp'
import { requestSendOtp } from './functions'

const LoginPage = (): JSX.Element => {
  const [otp, setOtp] = useState<string>('')
  const login = useLogin()
  const notify = useNotify()
  const pathName = window.location.pathname
  const currentId = last(split('/')(replace('/login', '')(pathName))) as string
  log.debug({ currentId })
  const handleSubmit = (e: any): void => {
    e.preventDefault()
    login({ id: currentId, otp }).catch(() => {
      notify('ワンタイムパスワードの認証に失敗しました。')
    })
  }
  useEffect(() => {
    requestSendOtp(currentId)
  }, [])
  return (
    <Grid
      container
      display="flex"
      justifyContent="center"
      alignContent="center">
      <Box display="grid" justifyContent="center" marginY={5}>
        <Box display="grid" justifyContent="center" marginY={1}>
          <Typography
            variant="h6"
            sx={{
              whiteSpace: 'pre-line'
            }}>
            {'テラシテRサービス'}
          </Typography>
        </Box>
        <Box display="grid" justifyContent="center" marginY={2}>
          <Typography
            variant="caption"
            sx={{
              borderBottom: 2,
              borderColor: 'GrayText',
              whiteSpace: 'pre-line'
            }}>
            {
              '平素より平素よりお世話になります、中部電力ミライズコネクト　テラシテR事務局でございます。\r\n以下欄に先ほど送付いたしましたログインパスワードをご入力いただき、ログインパスワードをご入力ください。\r\nなお、ログイン後30分でセッションが切れますのでご注意ください。'
            }
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignContent="center">
          <form onSubmit={handleSubmit}>
            <TextField
              label="ここに入力"
              name="otp"
              type="text"
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value)
              }}
            />
          </form>
          <Button onClick={handleSubmit}>{`送信`}</Button>
        </Box>
      </Box>
    </Grid>
  )
}

export default LoginPage
